//Если вернем OnboardingTooltip обратно, то нужно будет пройтись по всему проекту
//и раскомментировать window.updateOnboardingElements?.();

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { EmptyLayout } from "components/BaseLayout";
import { AuthenticationGuard, ActionModals, OnboardingTooltip } from "components";
import { LoginPage } from "pages";
import { routes } from "constants/routes";
import { RoutesList } from "RoutesList";

import "./App.css";

const App = observer(() => {
  return (
    <BrowserRouter>
      <AuthenticationGuard
        render={({ isAuthenticated }) =>
          !isAuthenticated ? (
            <Routes>
              <Route
                path={routes.login}
                element={
                  <EmptyLayout showHeader={true}>
                    <LoginPage />
                  </EmptyLayout>
                }
              />
              <Route path="*" element={<Navigate to={routes.login} replace />} />
            </Routes>
          ) : (
            <RoutesList />
          )
        }
      />
      <ActionModals />
    </BrowserRouter>
  );
});

export default App;
